// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__Vf7Su","tabDesktop":"styles_tabDesktop__w3V5U","tabPhone":"styles_tabPhone__-aKcx","tabPhone__list":"styles_tabPhone__list__bV5Nv"};